"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3924],{

/***/ 18733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ ActivityFilters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1582);
/* harmony import */ var _radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18188);
/* harmony import */ var components_primitives_Collapsible__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61194);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59417);






const ActivityFilters = (param)=>{
    let { open , setOpen , activityTypes , setActivityTypes  } = param;
    const filters = [
        {
            type: "sale",
            name: "Sales",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faShoppingCart */ .sq$
        },
        {
            type: "ask",
            name: "Listings",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTag */ .LEN
        },
        {
            type: "bid",
            name: "Offers",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faHand */ .ioV
        },
        {
            type: "transfer",
            name: "Transfer",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faRightLeft */ .eRx
        },
        {
            type: "mint",
            name: "Mint",
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faSeedling */ .YKZ
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_5__/* .Root */ .fC, {
        open: open,
        onOpenChange: setOpen,
        style: {
            transition: "width .5s",
            width: open ? 320 : 0
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Collapsible__WEBPACK_IMPORTED_MODULE_2__/* .CollapsibleContent */ .Fw, {
            css: {
                position: "sticky",
                top: 16 + 80,
                height: "max-content",
                overflow: "auto"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                direction: "column",
                css: {
                    "& > div:first-of-type": {
                        pt: 0
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                        style: "subtitle1",
                        css: {
                            mb: "$4",
                            whiteSpace: "nowrap"
                        },
                        children: "Event Type"
                    }),
                    filters.map((filter)=>{
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                            css: {
                                mb: "$3",
                                gap: "$3"
                            },
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                    css: {
                                        color: "$gray11"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                        icon: filter.icon,
                                        width: 16,
                                        height: 16
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                    style: "body1",
                                    css: {
                                        flex: 1
                                    },
                                    children: filter.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    align: "center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Switch */ .rs, {
                                        checked: activityTypes === null || activityTypes === void 0 ? void 0 : activityTypes.includes(filter.type),
                                        onCheckedChange: (checked)=>{
                                            if (checked) {
                                                setActivityTypes([
                                                    ...activityTypes,
                                                    filter.type
                                                ]);
                                            } else {
                                                setActivityTypes(activityTypes.filter((item)=>{
                                                    return item != filter.type;
                                                }));
                                            }
                                        }
                                    })
                                })
                            ]
                        }, filter.type);
                    })
                ]
            })
        })
    }, "hi");
};


/***/ }),

/***/ 31322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ActivityTable; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1582);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5678);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25511);
/* harmony import */ var viem__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(66373);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59417);
/* harmony import */ var _LoadingSpinner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74431);
/* harmony import */ var components_primitives_Img__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68916);
/* harmony import */ var utils_optimizeImage__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(77497);
/* harmony import */ var utils_numbers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23701);















const ActivityTable = (param)=>{
    let { data  } = param;
    const loadMoreRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const loadMoreObserver = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_3__/* .useIntersectionObserver */ .S1)(loadMoreRef, {});
    const activities = data.data;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            data.fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !data.isValidating && !data.isFetchingPage && activities && activities.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/icons/activity-icon.svg",
                        width: 40,
                        height: 40
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                        children: "No activity yet"
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                direction: "column",
                css: {
                    width: "100%",
                    pb: "$2"
                },
                children: [
                    activities.map((activity, i)=>{
                        if (!activity) return null;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActivityTableRow, {
                            activity: activity
                        }, "".concat(activity === null || activity === void 0 ? void 0 : activity.txHash, "-").concat(i));
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                        ref: loadMoreRef,
                        css: {
                            height: 20
                        }
                    })
                ]
            }),
            data.isValidating && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                align: "center",
                justify: "center",
                css: {
                    py: "$5"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LoadingSpinner__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
            })
        ]
    });
};
const logos = {
    transfer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faRightLeft */ .eRx,
        width: 16,
        height: 16
    }),
    sale: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faShoppingCart */ .sq$,
        width: 16,
        height: 16
    }),
    mint: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faSeedling */ .YKZ,
        width: 16,
        height: 16
    }),
    burned: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faTrash */ .$aW,
        width: 16,
        height: 16
    }),
    listing_canceled: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faXmark */ .g82,
        width: 16,
        height: 16
    }),
    ask_cancel: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faXmark */ .g82,
        width: 16,
        height: 16
    }),
    offer_canceled: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faXmark */ .g82,
        width: 16,
        height: 16
    }),
    ask: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faTag */ .LEN,
        width: 16,
        height: 16
    }),
    bid: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faHand */ .ioV,
        width: 16,
        height: 16
    })
};
const activityTypeToDesciptionMap = {
    ask_cancel: "Listing Canceled",
    bid_cancel: "Offer Canceled",
    mint: "Mint",
    ask: "List",
    bid: "Offer",
    transfer: "Transfer",
    sale: "Sale"
};
const activityTypeToDesciption = (activityType)=>{
    return activityTypeToDesciptionMap[activityType] || activityType;
};
const ActivityTableRow = (param)=>{
    let { activity  } = param;
    var _marketplaceChain_blockExplorers, _marketplaceChain_blockExplorers_default, _activity_token, _activity_token1, _activity_collection, _activity_token2, _activity_token3, _activity_collection1, _activity_token4, _activity_token5, _activity_collection2, _activity_price_amount, _activity_price_amount1, _activity_price_currency, _activity_order, _activity_order_source, _activity_order1, _activity_order_source1, _activity_order2, _activity_order_source2;
    const isSmallDevice = (0,react_responsive__WEBPACK_IMPORTED_MODULE_12__.useMediaQuery)({
        maxWidth: 700
    });
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useMarketplaceChain */ .gw)();
    const blockExplorerBaseUrl = (marketplaceChain === null || marketplaceChain === void 0 ? void 0 : (_marketplaceChain_blockExplorers = marketplaceChain.blockExplorers) === null || _marketplaceChain_blockExplorers === void 0 ? void 0 : (_marketplaceChain_blockExplorers_default = _marketplaceChain_blockExplorers.default) === null || _marketplaceChain_blockExplorers_default === void 0 ? void 0 : _marketplaceChain_blockExplorers_default.url) || "https://etherscan.io";
    const href = (activity === null || activity === void 0 ? void 0 : (_activity_token = activity.token) === null || _activity_token === void 0 ? void 0 : _activity_token.tokenId) ? "/".concat(marketplaceChain.routePrefix, "/asset/").concat(activity === null || activity === void 0 ? void 0 : activity.contract, ":").concat(activity === null || activity === void 0 ? void 0 : (_activity_token1 = activity.token) === null || _activity_token1 === void 0 ? void 0 : _activity_token1.tokenId) : "/".concat(marketplaceChain.routePrefix, "/collection/").concat(activity === null || activity === void 0 ? void 0 : (_activity_collection = activity.collection) === null || _activity_collection === void 0 ? void 0 : _activity_collection.collectionId);
    if (!activity) {
        return null;
    }
    const imageSrc = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        var _activity_token, _activity_token1, _activity_collection, _activity_collection1;
        return (0,utils_optimizeImage__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((activity === null || activity === void 0 ? void 0 : (_activity_token = activity.token) === null || _activity_token === void 0 ? void 0 : _activity_token.tokenId) ? (activity === null || activity === void 0 ? void 0 : (_activity_token1 = activity.token) === null || _activity_token1 === void 0 ? void 0 : _activity_token1.tokenImage) || (activity === null || activity === void 0 ? void 0 : (_activity_collection = activity.collection) === null || _activity_collection === void 0 ? void 0 : _activity_collection.collectionImage) : activity === null || activity === void 0 ? void 0 : (_activity_collection1 = activity.collection) === null || _activity_collection1 === void 0 ? void 0 : _activity_collection1.collectionImage, 250);
    }, [
        activity === null || activity === void 0 ? void 0 : (_activity_token2 = activity.token) === null || _activity_token2 === void 0 ? void 0 : _activity_token2.tokenId,
        activity === null || activity === void 0 ? void 0 : (_activity_token3 = activity.token) === null || _activity_token3 === void 0 ? void 0 : _activity_token3.tokenImage,
        activity === null || activity === void 0 ? void 0 : (_activity_collection1 = activity.collection) === null || _activity_collection1 === void 0 ? void 0 : _activity_collection1.collectionImage
    ]);
    let activityDescription = activityTypeToDesciption((activity === null || activity === void 0 ? void 0 : activity.type) || "");
    let attributeDescription = "";
    /*
  Ignoring typescript warnings as API types for the 
  criteria object are incorrectly assigned due to joi.alternatives
  */ if (activityDescription === "Offer") {
        var _activity_order3, _activity_order_criteria, _activity_order4, _activity_order_criteria1;
        /* @ts-ignore */ if (((_activity_order3 = activity.order) === null || _activity_order3 === void 0 ? void 0 : (_activity_order_criteria = _activity_order3.criteria) === null || _activity_order_criteria === void 0 ? void 0 : _activity_order_criteria.kind) === "collection") {
            activityDescription = "Collection Offer";
        /* @ts-ignore */ } else if (((_activity_order4 = activity.order) === null || _activity_order4 === void 0 ? void 0 : (_activity_order_criteria1 = _activity_order4.criteria) === null || _activity_order_criteria1 === void 0 ? void 0 : _activity_order_criteria1.kind) === "attribute") {
            var _activity_order5, _activity_order_criteria2, _activity_order_criteria_data, _activity_order_criteria_data_attribute, _activity_order6, _activity_order_criteria3;
            activityDescription = "Attribute Offer";
            /* @ts-ignore */ attributeDescription = "".concat((_activity_order5 = activity.order) === null || _activity_order5 === void 0 ? void 0 : (_activity_order_criteria2 = _activity_order5.criteria) === null || _activity_order_criteria2 === void 0 ? void 0 : (_activity_order_criteria_data = _activity_order_criteria2.data) === null || _activity_order_criteria_data === void 0 ? void 0 : (_activity_order_criteria_data_attribute = _activity_order_criteria_data.attribute) === null || _activity_order_criteria_data_attribute === void 0 ? void 0 : _activity_order_criteria_data_attribute.key, ": ").concat((_activity_order6 = activity.order) === null || _activity_order6 === void 0 ? void 0 : (_activity_order_criteria3 = _activity_order6.criteria) === null || _activity_order_criteria3 === void 0 ? void 0 : _activity_order_criteria3.data.attribute.value);
        }
    }
    const { displayName: toDisplayName  } = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useENSResolver */ .Af)(activity === null || activity === void 0 ? void 0 : activity.toAddress);
    const { displayName: fromDisplayName  } = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useENSResolver */ .Af)(activity === null || activity === void 0 ? void 0 : activity.fromAddress);
    if (isSmallDevice) {
        var _activity_order7, _activity_order_source3, _activity_order8, _activity_order_source4, _activity_order9, _activity_order_source5, _activity_token6, _activity_token7, _activity_token8, _activity_collection3, _activity_price_amount2, _activity_price_amount3, _activity_price_currency1;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .TableRow */ .SC, {
            css: {
                gridTemplateColumns: "1fr"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                css: {
                    pr: "0",
                    width: "100%",
                    minWidth: 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                    direction: "column",
                    css: {
                        gap: "$3"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                            css: {
                                color: "$gray11"
                            },
                            align: "center",
                            justify: "between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                    align: "center",
                                    children: [
                                        activity.type && logos[activity.type],
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                            style: "subtitle1",
                                            ellipsify: true,
                                            css: {
                                                ml: "$2",
                                                color: "$gray11",
                                                fontSize: "14px",
                                                minWidth: 0
                                            },
                                            children: activityDescription
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                    align: "center",
                                    justify: "end",
                                    css: {
                                        gap: "$3"
                                    },
                                    children: [
                                        !!((_activity_order7 = activity.order) === null || _activity_order7 === void 0 ? void 0 : (_activity_order_source3 = _activity_order7.source) === null || _activity_order_source3 === void 0 ? void 0 : _activity_order_source3.icon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            width: "20px",
                                            height: "20px",
                                            src: ((_activity_order8 = activity.order) === null || _activity_order8 === void 0 ? void 0 : (_activity_order_source4 = _activity_order8.source) === null || _activity_order_source4 === void 0 ? void 0 : _activity_order_source4.icon) || "",
                                            alt: "".concat((_activity_order9 = activity.order) === null || _activity_order9 === void 0 ? void 0 : (_activity_order_source5 = _activity_order9.source) === null || _activity_order_source5 === void 0 ? void 0 : _activity_order_source5.name, " Source")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                            style: "subtitle3",
                                            css: {
                                                fontSize: "12px",
                                                color: "$gray11"
                                            },
                                            children: (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useTimeSince */ .vS)(activity === null || activity === void 0 ? void 0 : activity.timestamp)
                                        }),
                                        activity.txHash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Anchor */ .ee, {
                                            color: "primary",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            href: "".concat(blockExplorerBaseUrl, "/tx/").concat(activity.txHash),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__/* .FontAwesomeIcon */ .G, {
                                                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faExternalLink */ .gJF,
                                                width: 12,
                                                height: 15
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                            align: "center",
                            justify: "between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: href,
                                    passHref: true,
                                    style: {
                                        maxWidth: "100%",
                                        minWidth: 0
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                        align: "center",
                                        children: [
                                            imageSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                style: {
                                                    borderRadius: "4px",
                                                    objectFit: "cover"
                                                },
                                                loader: (param)=>{
                                                    let { src  } = param;
                                                    return src;
                                                },
                                                src: imageSrc,
                                                alt: "".concat((_activity_token6 = activity.token) === null || _activity_token6 === void 0 ? void 0 : _activity_token6.tokenName, " Token Image"),
                                                width: 48,
                                                height: 48
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                                align: "start",
                                                direction: "column",
                                                css: {
                                                    ml: "$2"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                                        ellipsify: true,
                                                        css: {
                                                            fontSize: "14px"
                                                        },
                                                        children: ((_activity_token7 = activity.token) === null || _activity_token7 === void 0 ? void 0 : _activity_token7.tokenName) || ((_activity_token8 = activity.token) === null || _activity_token8 === void 0 ? void 0 : _activity_token8.tokenId) || ((_activity_collection3 = activity.collection) === null || _activity_collection3 === void 0 ? void 0 : _activity_collection3.collectionName)
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                                        ellipsify: true,
                                                        css: {
                                                            fontSize: "12px",
                                                            color: "$gray11"
                                                        },
                                                        children: attributeDescription
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                activity.price && ((_activity_price_amount2 = activity.price.amount) === null || _activity_price_amount2 === void 0 ? void 0 : _activity_price_amount2.decimal) !== 0 && activity.type && activity.type !== "transfer" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                    direction: "column",
                                    align: "center",
                                    css: {
                                        minWidth: "max-content",
                                        pl: "$2"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .FormatCryptoCurrency */ .gv, {
                                        amount: (_activity_price_amount3 = activity.price.amount) === null || _activity_price_amount3 === void 0 ? void 0 : _activity_price_amount3.decimal,
                                        address: (_activity_price_currency1 = activity.price.currency) === null || _activity_price_currency1 === void 0 ? void 0 : _activity_price_currency1.contract,
                                        logoHeight: 16,
                                        textStyle: "subtitle1",
                                        css: {
                                            mr: "$2",
                                            fontSize: "14px"
                                        }
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "-"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                            align: "baseline",
                            css: {
                                gap: "$2"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    style: "subtitle3",
                                    css: {
                                        fontSize: "12px",
                                        color: "$gray11"
                                    },
                                    children: "From"
                                }),
                                activity.fromAddress && activity.fromAddress !== viem__WEBPACK_IMPORTED_MODULE_14__/* .zeroAddress */ .D ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: "/portfolio/".concat(activity.fromAddress),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        style: "subtitle3",
                                        css: {
                                            color: "$primary11",
                                            "&:hover": {
                                                color: "$primary10"
                                            }
                                        },
                                        children: fromDisplayName
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "-"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    style: "subtitle3",
                                    css: {
                                        fontSize: "12px",
                                        color: "$gray11"
                                    },
                                    children: "to"
                                }),
                                activity.toAddress && activity.toAddress !== viem__WEBPACK_IMPORTED_MODULE_14__/* .zeroAddress */ .D ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: "/portfolio/".concat(activity.toAddress),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        style: "subtitle3",
                                        css: {
                                            color: "$primary11",
                                            "&:hover": {
                                                color: "$primary10"
                                            }
                                        },
                                        children: toDisplayName
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "-"
                                })
                            ]
                        })
                    ]
                })
            })
        }, activity.txHash);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .TableRow */ .SC, {
        css: {
            gridTemplateColumns: ".75fr 1.25fr .9fr 1fr 1fr 1fr 1.1fr"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                css: {
                    color: "$gray11",
                    minWidth: 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                    align: "center",
                    title: activityDescription,
                    children: [
                        activity.type && logos[activity.type],
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            style: "subtitle1",
                            ellipsify: true,
                            css: {
                                ml: "$2",
                                color: "$gray11",
                                fontSize: "14px",
                                cursor: "default"
                            },
                            children: activityDescription
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                css: {
                    minWidth: 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                    href: href,
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                        align: "center",
                        children: [
                            imageSrc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Img__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                style: {
                                    borderRadius: "4px",
                                    objectFit: "cover"
                                },
                                loader: (param)=>{
                                    let { src  } = param;
                                    return src;
                                },
                                src: imageSrc,
                                alt: "Activity Token Image",
                                width: 52,
                                height: 52
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                align: "start",
                                direction: "column",
                                css: {
                                    ml: "$3"
                                },
                                style: {
                                    maxWidth: "100%",
                                    minWidth: 0,
                                    overflow: "hidden"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        style: "subtitle1",
                                        ellipsify: true,
                                        css: {
                                            fontSize: "14px"
                                        },
                                        children: ((_activity_token4 = activity.token) === null || _activity_token4 === void 0 ? void 0 : _activity_token4.tokenName) || ((_activity_token5 = activity.token) === null || _activity_token5 === void 0 ? void 0 : _activity_token5.tokenId) || ((_activity_collection2 = activity.collection) === null || _activity_collection2 === void 0 ? void 0 : _activity_collection2.collectionName)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        ellipsify: true,
                                        css: {
                                            fontSize: "12px",
                                            color: "$gray11"
                                        },
                                        children: attributeDescription
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                children: activity.price && ((_activity_price_amount = activity.price.amount) === null || _activity_price_amount === void 0 ? void 0 : _activity_price_amount.decimal) !== 0 && activity.type && activity.type !== "transfer" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                    align: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .FormatCryptoCurrency */ .gv, {
                        amount: (_activity_price_amount1 = activity.price.amount) === null || _activity_price_amount1 === void 0 ? void 0 : _activity_price_amount1.decimal,
                        address: (_activity_price_currency = activity.price.currency) === null || _activity_price_currency === void 0 ? void 0 : _activity_price_currency.contract,
                        logoHeight: 16,
                        textStyle: "h6",
                        css: {
                            mr: "$2",
                            fontSize: "16px"
                        }
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                children: activity.amount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                    direction: "column",
                    align: "start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            style: "subtitle3",
                            color: "subtle",
                            children: "Quantity"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            style: "subtitle3",
                            children: (0,utils_numbers__WEBPACK_IMPORTED_MODULE_10__/* .formatNumber */ .uf)(activity.amount)
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                css: {
                    minWidth: 0
                },
                children: activity.fromAddress && activity.fromAddress !== viem__WEBPACK_IMPORTED_MODULE_14__/* .zeroAddress */ .D ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                    direction: "column",
                    align: "start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            style: "subtitle3",
                            color: "subtle",
                            children: "From"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                            href: "/portfolio/".concat(activity.fromAddress),
                            style: {
                                maxWidth: "100%",
                                minWidth: 0,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                style: "subtitle3",
                                css: {
                                    color: "$primary11",
                                    "&:hover": {
                                        color: "$primary10"
                                    }
                                },
                                ellipsify: true,
                                children: fromDisplayName
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                css: {
                    minWidth: 0
                },
                children: activity.toAddress && activity.toAddress !== viem__WEBPACK_IMPORTED_MODULE_14__/* .zeroAddress */ .D ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                    direction: "column",
                    align: "start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            style: "subtitle3",
                            color: "subtle",
                            children: "To"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                            href: "/portfolio/".concat(activity.toAddress),
                            style: {
                                maxWidth: "100%",
                                minWidth: 0,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                style: "subtitle3",
                                css: {
                                    color: "$primary11",
                                    "&:hover": {
                                        color: "$primary10"
                                    }
                                },
                                ellipsify: true,
                                children: toDisplayName
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .TableCell */ .pj, {
                css: {
                    minWidth: 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                    align: "center",
                    justify: "end",
                    css: {
                        gap: "$3"
                    },
                    children: [
                        !!((_activity_order = activity.order) === null || _activity_order === void 0 ? void 0 : (_activity_order_source = _activity_order.source) === null || _activity_order_source === void 0 ? void 0 : _activity_order_source.icon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            width: "20px",
                            height: "20px",
                            src: ((_activity_order1 = activity.order) === null || _activity_order1 === void 0 ? void 0 : (_activity_order_source1 = _activity_order1.source) === null || _activity_order_source1 === void 0 ? void 0 : _activity_order_source1.icon) || "",
                            alt: "".concat((_activity_order2 = activity.order) === null || _activity_order2 === void 0 ? void 0 : (_activity_order_source2 = _activity_order2.source) === null || _activity_order_source2 === void 0 ? void 0 : _activity_order_source2.name, " Source")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            style: "subtitle3",
                            color: "subtle",
                            ellipsify: true,
                            children: (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useTimeSince */ .vS)(activity === null || activity === void 0 ? void 0 : activity.timestamp)
                        }),
                        activity.txHash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Anchor */ .ee, {
                            href: "".concat(blockExplorerBaseUrl, "/tx/").concat(activity.txHash),
                            color: "primary",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_7__/* .FontAwesomeIcon */ .G, {
                                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faExternalLink */ .gJF,
                                width: 12,
                                height: 15
                            })
                        })
                    ]
                })
            })
        ]
    }, activity.txHash);
};


/***/ }),

/***/ 57813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ FilterButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99603);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1582);




const FilterButton = (param)=>{
    let { open , setOpen  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
        css: {
            justifyContent: "center",
            width: "48px",
            height: "48px"
        },
        type: "button",
        onClick: ()=>setOpen(!open),
        size: "small",
        color: "gray3",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
            icon: open ? _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faChevronLeft */ .A35 : _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faFilter */ .G_j,
            width: 16,
            height: 16
        })
    });
};


/***/ })

}]);